// ##### Komarov 2025-07-31
import React, { useEffect } from 'react';
// ##### 24-07-22 Komarov
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
// ##### 23-09-14 Komarov
// import './footer.css'
// ##### 25-03-13 Komarov
import {
  BottomRow
} from './helpers';
// ##### 25-04-30 Komarov
import PagesLinks from './PagesLinks';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import ssrPages from '../../../../server/helpers/ssrPages';
import useValidateQuery from '../../../helpers/useValidateQuery';
import { getAttractionsOverview, getCitiesOverview, getHotelsOverview, getOccupiedCities } from '../../../Redux/actions';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-13
const Footer = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('Footer', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for Footer (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  const dispatch = useDispatch();
  const language = useSelector(state => state.language);
  const { cities_overview_top_loaded } = useSelector(
    state => state.cities
  );
  const { occupied_cities_top_loaded } = useSelector(
    state => state.cities
  );
  const { attractions_top_loaded } = useSelector(state => state.cities);
  const { hotels_overview_top_loaded } = useSelector(
    state => state.hotels
  );
  const location = useLocation();
  const search_data = useValidateQuery();

  const url = `${location.pathname}${location.search}`;
  let browserUrl = url.substring(3);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    browserUrl = url.substring(3);
  }, [language, url]);

  const isItOtherCitiesPage =
    browserUrl === ssrPages['Other Cities'] || search_data?.spid == 191;
  const isItOtherHotelsPage =
    browserUrl === ssrPages['Other Hotels'] || search_data?.spid == 365;
  // ##### 25-01-14 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  const { user: currentUser } = useSelector(state => state.auth);

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (cities_overview_top_loaded[language] && occupied_cities_top_loaded[language] && attractions_top_loaded[language]) return;
      const params = {
        user_id: currentUser.user_id,
        // ##### 24-08-05 Komarov
        refpartner: company_id,
        language,
        primary_objects_list: isItOtherCitiesPage ? 0 : 1,
        section_name: 'CITIES Overview',
      };
      dispatch(getCitiesOverview(params));
    },
    // ##### 24-10-28 Komarov
    [language, url]
  );

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (cities_overview_top_loaded[language] && occupied_cities_top_loaded[language] && attractions_top_loaded[language]) return;
      const params = {
        user_id: currentUser.user_id,
        // ##### 24-08-05 Komarov
        refpartner: company_id,
        language,
        primary_objects_list: isItOtherCitiesPage ? 0 : 1,
        section_name: 'ATTRACTIONS',
      };
      dispatch(getAttractionsOverview(params));
    },
    // ##### 24-10-28 Komarov
    [language, url]
  );

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (cities_overview_top_loaded[language] && occupied_cities_top_loaded[language] && attractions_top_loaded[language]) return;
      const params = {
        user_id: currentUser.user_id,
        // ##### 24-08-05 Komarov
        refpartner: company_id,
        language,
        primary_objects_list: isItOtherCitiesPage ? 0 : 1,
        section_name: 'Occupied CITIES',
      };
      dispatch(getOccupiedCities(params));
    },
    // ##### 24-10-28 Komarov
    [language, url]
  );

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (hotels_overview_top_loaded[language]) return;
      dispatch(
        getHotelsOverview({ language, primary_objects_list: isItOtherHotelsPage ? 0 : 1 })
      );
    },
    // ##### 24-10-28 Komarov
    [language, url]
  );
  // ##### Komarov 2025-07-30
  return (
    <footer className="footer" data-component="FooterSsr">
      <Container
        fluid="xs,sm,md,lg,xl"
        style={{ marginLeft: 'auto', marginRight: 'auto', width: '80%' }}
      >
        <Row
          xs={1}
          // ##### 23-03-30 Komarov
          // sm={1}
          sm={2}
          md={2}
          lg={3}
        >
          {cities_overview_top_loaded[language] && occupied_cities_top_loaded[language] && attractions_top_loaded[language] && hotels_overview_top_loaded[language] && <PagesLinks />}
        </Row>
        {/* ##### 25-03-13 Komarov */}
        <BottomRow />
      </Container>
    </footer>
  );
};

// ##### 25-05-21 Komarov
export default Footer;
